import { motion } from "framer-motion";
import { Target, Zap, Lock, Rocket, Brain } from "lucide-react";

const VosEnjeuxSection = () => {
  const enjeux = [
    {
      icon: <Zap className="w-5 h-5" />,
      title: "Moderniser un SI existant",
      description: "Sans risque pour la production"
    },
    {
      icon: <Rocket className="w-5 h-5" />,
      title: "Accélérer la mise en production",
      description: "Time-to-market optimisé"
    },
    {
      icon: <Lock className="w-5 h-5" />,
      title: "Garantir la stabilité",
      description: "Zéro compromis sur la qualité"
    },
    {
      icon: <Brain className="w-5 h-5" />,
      title: "Intégrer l'IA en toute sécurité",
      description: "Sans compromettre vos données"
    }
  ];

  return (
    <section className="section-spacing relative">
      {/* Background - LIGHTER */}
      <div className="absolute inset-0 bg-[#070B1A]" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0A0F20]/40 to-transparent" />
      
      <div className="lenvia-container relative z-10">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Left - Content */}
          <motion.div
            initial={{ opacity: 0, x: -25 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-flex items-center gap-2.5 mb-6">
              <Target className="w-4 h-4 text-lenvia-blue" />
              <span className="text-xs font-bold tracking-[0.2em] text-slate-400 uppercase">
                Vos contraintes
              </span>
            </span>
            
            <h2 className="font-heading text-3xl md:text-4xl lg:text-[2.75rem] font-bold tracking-tight text-white mb-6 leading-[1.1]">
              Nous comprenons{" "}
              <span className="gradient-text">vos enjeux</span>
            </h2>
            
            <p className="text-lg lg:text-xl text-slate-300 leading-relaxed mb-4">
              Stabilité, performance, sécurité et pression métier — nous maîtrisons les contraintes des systèmes critiques.
            </p>
            <p className="text-base text-slate-400 leading-relaxed">
              Nous intervenons pour sécuriser vos décisions techniques et accélérer vos livraisons.
            </p>
          </motion.div>
          
          {/* Right - Cards */}
          <motion.div
            initial={{ opacity: 0, x: 25 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="grid grid-cols-1 sm:grid-cols-2 gap-5"
          >
            {enjeux.map((enjeu, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.2 + index * 0.1 }}
                className="group"
              >
                <div className="glass-card p-6 h-full hover:bg-white/[0.04] transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 rounded-xl bg-lenvia-blue/12 border border-lenvia-blue/25 flex items-center justify-center text-lenvia-blue group-hover:bg-lenvia-blue/18 group-hover:scale-105 transition-all flex-shrink-0">
                      {enjeu.icon}
                    </div>
                    <div>
                      <h3 className="font-heading text-base font-bold text-white mb-1.5 leading-snug">
                        {enjeu.title}
                      </h3>
                      <p className="text-sm text-slate-400 leading-relaxed">
                        {enjeu.description}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default VosEnjeuxSection;
